import React, {useState, useEffect} from "react";
import {
    Typography,
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
    Checkbox, Button,
} from "@material-tailwind/react";
import RoleForm from '../shared/role_form';
import SideNav from "../layout/sidenav";
import NavBar from "../layout/navbar";
import Footer from "../layout/footer";

const Discounts = ({routes, username, role}) => {
    const [discounts, setDiscounts] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [openSidenav, setOpenSidenav] = useState(false);
    const [discountType, setDiscountType] = useState('normal'); /* normal - special - unofficial */

    useEffect(() => {
        fetch("/discounts.json")
            .then((response) => response.json())
            .then((data) => setDiscounts(data))
            .catch((error) => console.error("Error fetching discounts:", error));
    }, []);

    const toggleDiscounts = async (type) => {
        await loadDiscounts(type);
        setDiscountType(type);
    }

    const loadDiscounts = async (type) => {
        let url = `/discounts.json`;

        if (type === 'special') {
            url = `/discounts/special_discounts.json`;
        }

        try {
            const response = await fetch(url);
            const data = await response.json();
            setDiscounts(data);
        } catch (err) {
            console.error("Error fetching discounts:", err);
        }
    };

    const discountTabs = [
        {
            label: "Descuentos",
            value: "normal",
        },
        {
            label: "Descuentos especiales",
            value: "special",
        },
        /*{
            label: "Descuentos extraoficiales",
            value: "unofficial",
        },*/
    ];

    if (selectedRole) {
        return (
            <>
                <SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="p-4 xl:ml-80">
                    <NavBar routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                    <div className="flex flex-wrap mt-6">
                        <div className="w-full px-4">
                            <RoleForm cancel={() => setSelectedRole(null)}/>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </>
        )
    } else {
        return (
            <>
                {/*<SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav} roleKey={role}/>*/}
                {/*<div className="p-4 xl:ml-80">*/}
                {/*    <NavBar*/}
                {/*        routes={routes}*/}
                {/*        setOpenSidenav={setOpenSidenav}*/}
                {/*        openSidenav={openSidenav}*/}
                {/*        userName={username}*/}
                {/*    />*/}
                    <div className="mt-12">
                        <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                            <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                                <CardHeader
                                    floated={false}
                                    shadow={false}
                                    color="transparent"
                                    className="m-0 flex items-center justify-between p-6"
                                >
                                    <div>
                                        <Typography variant="h6" color="blue-gray" className="mb-1">
                                            Descuentos
                                        </Typography>
                                        <a href='discounts/register_discount' className="flex">
                                            <Button
                                                variant={"gradient"}
                                                color={"blue"}
                                                className="flex items-center gap-4 px-4 capitalize"
                                                fullWidth
                                                size="sm"
                                            >
                                                <Typography color="inherit" className="font-medium capitalize">
                                                    Alta descuento especial
                                                </Typography>
                                            </Button>
                                        </a>
                                    </div>
                                </CardHeader>
                                <CardBody className="overflow-x-scroll px-0 pt-0 pb-2">
                                    <Tabs value={discountType}>
                                        <TabsHeader>
                                            {discountTabs.map(({label, value}) => (
                                                <Tab key={value} value={value}
                                                     onClick={() => toggleDiscounts(value)}>
                                                    {label}
                                                </Tab>
                                            ))}
                                        </TabsHeader>
                                        <TabsBody>
                                            {discountTabs.map(({label, value}) => (
                                                <TabPanel key={value} value={value}>
                                                    <table className="w-full min-w-[640px] table-auto"
                                                           key={discountType}
                                                           value={discountType}>
                                                        <thead>
                                                        <tr>
                                                            {["Nombre", "Porcentaje", "Descripción", "Inicio", "Fin", "Activo", "Actions"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {discounts.map((discount, key) => {
                                                            const className = `py-3 px-5 ${
                                                                key === discounts.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;

                                                            return (
                                                                <tr key={discount.id}>
                                                                    <td className={className}>
                                                                        <Typography variant="small" color="blue-gray"
                                                                                    className="font-bold">
                                                                            {discount.name}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.percentage}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.description}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.start_date}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.end_date}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.active}
                                                                        </Typography>
                                                                        <Checkbox color="blue" checked={discount.active}  disabled={true}/>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Menu placement="left-start">
                                                                            <MenuHandler>
                                                                                <IconButton size="sm" variant="text"
                                                                                            color="blue-gray">
                                                                                    ...
                                                                                </IconButton>
                                                                            </MenuHandler>
                                                                            <MenuList>
                                                                                {/*<MenuItem*/}
                                                                                {/*    onClick={() => setSelectedRole(lot.id)}>Editar</MenuItem>*/}
                                                                                {/*<MenuItem>Desactivar</MenuItem>*/}
                                                                            </MenuList>
                                                                        </Menu>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                        </tbody>
                                                    </table>
                                                </TabPanel>
                                            ))}
                                        </TabsBody>
                                    </Tabs>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                {/*    <Footer/>*/}
                {/*</div>*/}
            </>
        );
    }
};

export default Discounts;